import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch} from "react-redux"
import { Outlet } from "react-router-dom";
import News from "../components/News/News";
import Searchbar from "../components/Searchbar/Searchbar";
import { fetchNotifications } from "../store/notification/notificationsActions";

export default function NotificationsPage() {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    dispatch(fetchNotifications(
      
    ));
  }, [dispatch]);



  return (
    <>
      <div className="notificationspage two-flex-col-container">
        <div className="col1 npc-1">
          <div className="notificationspage-header">
            <span className="notifications-text">الإشعارات</span>
            {/* <span className="setting-icon-container">
              <NotificationIcon />
            </span> */}
          </div>
          <div className="user-notifications-content">
            <Outlet />
          </div>
        </div>
        <div className="col2 follow-sugg-news-container">
          <div className="follow-sugg-news-wrap">
            <Searchbar input={searchQuery}
              setInput={(value) => setSearchQuery(value)} />
            <News />
            {/* <WhoToFollow /> */}
          </div>
        </div>
      </div>
    </>
  );
}
